import polyglotI18nProvider from "ra-i18n-polyglot"
import { resolveBrowserLocale } from "react-admin"
import englishMessages from "ra-language-english"
import russianMessages from "ra-language-russian"
import customEnglishMessages from "./en"
import customRussianMessages from "./ru"

// Синхронные сообщения для каждой локали
const messages: { [key: string]: any } = {
    en: { ...englishMessages, ...customEnglishMessages },
    ru: { ...russianMessages, ...customRussianMessages },
}

const supportLanguages = [
    { locale: "en", name: "English" },
    { locale: "ru", name: "Русский" },
]

const messagesResolver = (locale: string) => {
    return messages[locale] || messages["en"]
}


export const i18nProvider = polyglotI18nProvider(locale =>messagesResolver(locale), resolveBrowserLocale(), supportLanguages)